import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IOSSwitch from "@components/common/Switch";

interface DisplayNSectionProps {
  showBarN: boolean;
  showChartN: boolean;
  onShowBarNChange: (value: boolean) => void;
  onShowChartNChange: (value: boolean) => void;
}

const DisplayNSection: React.FC<DisplayNSectionProps> = ({
  showBarN,
  showChartN,
  onShowBarNChange,
  onShowChartNChange,
}) => {
  return (
    <Accordion
      defaultExpanded
      sx={{ boxShadow: "none", border: "1px solid #eee" }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          N Display
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>Show Bar N</Typography>
            <IOSSwitch
              checked={showBarN}
              onChange={(e) => onShowBarNChange(e.target.checked)}
              size="small"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>Show Chart N</Typography>
            <IOSSwitch
              checked={showChartN}
              onChange={(e) => onShowChartNChange(e.target.checked)}
              size="small"
            />
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default DisplayNSection;
